<div id="forgot-password-container" fxLayout="column" fxLayoutAlign="center center">
  <mat-card class="example-container" fxFlex="30%" fxFlex.lt-md="65%" fxFlex.lt-sm="95%" >
    <mat-card-title>
      {{ titleText }}
      <p class = "help-text">{{ subTitleText }}</p>
    </mat-card-title>
      <form [formGroup]="forgotForm" (ngSubmit)="submitFun()">
        <mat-card-content>
          <mat-form-field >
              <label>{{ emailText }}</label>
              <input matInput formControlName="email">
              <mat-error *ngIf="errorHandling('email', 'required')">
                {{ emailError }}
             </mat-error>
            </mat-form-field>
            <mat-error *ngIf="(error.error === true)">{{error.msg}} </mat-error>
            <P class="success" *ngIf="(error.success === true)">{{error.msg}}</P>
        </mat-card-content>
            <mat-card-actions class = "right center-align">
              <button mat-flat-button [disabled]="!isformValid">{{ buttonText }}</button>
            </mat-card-actions>
    </form>
  
  </mat-card>
  </div>   